module.exports = __webpack_public_path__ + "static/media/TH.14415155.svg";